(function () {
  function formatMoney(cents) {
    if (cents == null || cents === '') return '';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var amount = parseInt(cents, 10);
    if (isNaN(amount)) return '';

    var formatString =
      window.__vtPpcMoneyFormat || (window.Shopify && window.Shopify.money_format) || '£{{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    if (!match) {
      return '£' + formatWithDelimiters(amount, 2);
    }

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(amount, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(amount, 2, "'", '.');
        break;
      case 'amount':
      default:
        value = formatWithDelimiters(amount, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initGallery(gallery) {
    if (gallery.getAttribute('data-vt-ppc-gallery-init') === 'true') return;
    gallery.setAttribute('data-vt-ppc-gallery-init', 'true');

    var main = gallery.querySelector('.vt-ppc__gallery-main-img');
    var thumbList = gallery.querySelectorAll('.vt-ppc__thumb[data-vt-ppc-thumb]');
    var dotList = gallery.querySelectorAll('.vt-ppc__gallery-dot[data-vt-ppc-dot]');
    if (!main || (!thumbList.length && !dotList.length)) return;

    var mainFrame = gallery.querySelector('.vt-ppc__gallery-main');
    var slideCount = Math.max(thumbList.length, dotList.length);
    var autoplayTimer = null;
    var autoplayResumeTimer = null;
    var AUTOPLAY_MS = 4500;
    var AUTOPLAY_RESUME_MS = 8000;

    function setGalleryIndex(index) {
      if (slideCount < 1) return;
      if (index < 0) index = slideCount - 1;
      if (index >= slideCount) index = 0;
      gallery.setAttribute('data-vt-ppc-slide', String(index));
      var srcNode = thumbList[index] || dotList[index];
      if (!srcNode) return;
      var src = srcNode.getAttribute('data-full-src');
      var alt = srcNode.getAttribute('data-alt') || '';
      if (!src) return;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
      main.alt = alt;
      if (mainFrame) {
        mainFrame.classList.toggle('vt-ppc__gallery-main--cover', index > 0);
      }
      thumbList.forEach(function (t, i) {
        var on = i === index;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dotList.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
    }

    function getActiveIndex() {
      var active = 0;
      dotList.forEach(function (d, i) {
        if (d.classList.contains('is-active')) active = i;
      });
      if (!dotList.length) {
        thumbList.forEach(function (t, i) {
          if (t.classList.contains('is-active')) active = i;
        });
      }
      return active;
    }

    function stopAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      autoplayTimer = null;
      if (autoplayResumeTimer) clearTimeout(autoplayResumeTimer);
      autoplayResumeTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (slideCount <= 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoplayTimer = setInterval(function () {
        setGalleryIndex(getActiveIndex() + 1);
      }, AUTOPLAY_MS);
    }

    function pauseAutoplayForUser() {
      stopAutoplay();
      autoplayResumeTimer = setTimeout(startAutoplay, AUTOPLAY_RESUME_MS);
    }

    thumbList.forEach(function (btn, index) {
      btn.addEventListener('click', function () {
        setGalleryIndex(index);
        pauseAutoplayForUser();
      });
    });

    dotList.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setGalleryIndex(index);
        pauseAutoplayForUser();
      });
    });

    startAutoplay();
    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', startAutoplay);
    gallery.addEventListener('focusin', stopAutoplay);
    gallery.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    var frame = gallery.querySelector('.vt-ppc__gallery-main');
    if (frame && dotList.length > 1) {
      var touchStartX = 0;
      frame.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );
      frame.addEventListener(
        'touchend',
        function (e) {
          var dx = e.changedTouches[0].screenX - touchStartX;
          if (Math.abs(dx) < 40) return;
          var active = 0;
          dotList.forEach(function (d, i) {
            if (d.classList.contains('is-active')) active = i;
          });
          if (dx < 0 && active < dotList.length - 1) setGalleryIndex(active + 1);
          if (dx > 0 && active > 0) setGalleryIndex(active - 1);
          pauseAutoplayForUser();
        },
        { passive: true }
      );
    }
  }

  function updateStickyBar(qty) {
    var sticky = document.querySelector('[data-vt-ppc-sticky]');
    if (!sticky) return;
    qty = String(qty);
    var variantEl = sticky.querySelector('[data-vt-ppc-sticky-variant]');
    var priceEl = sticky.querySelector('[data-vt-ppc-sticky-price]');
    var useBundleLabels = sticky.getAttribute('data-use-bundle-labels') !== 'false';
    var bundleLabel = sticky.getAttribute('data-label-' + qty);
    var price = parseInt(sticky.getAttribute('data-price-' + qty), 10);
    if (variantEl && useBundleLabels && bundleLabel) variantEl.textContent = bundleLabel;
    if (priceEl && !isNaN(price) && price > 0) priceEl.textContent = formatMoney(price);
  }

  function selectBundleQty(qty) {
    var radio = document.querySelector('[data-vt-ppc-bundle-radio][value="' + qty + '"]');
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    var form = radio.closest('form');
    if (form && form._vtPpcApplyBundle) form._vtPpcApplyBundle(qty);
  }

  function shouldAddToCartFromCta(el) {
    if (el.getAttribute('data-vt-ppc-scroll-only') === 'true') return false;
    if (el.getAttribute('data-vt-ppc-add-to-cart') === 'true') return true;
    if (el.getAttribute('data-vt-ppc-bundle-qty')) return true;
    if (el.classList.contains('vt-ppc__offer-btn')) return true;
    if (el.classList.contains('vt-ppc__final-card-btn')) return true;
    if (el.classList.contains('vt-ppc-hg__final-btn')) return true;
    return false;
  }

  function getPpcBuyForm() {
    var productForm = document.querySelector('product-form.vt-ppc-hg__buy-form, product-form.vt-ppc__buy-form');
    return productForm ? productForm.querySelector('form') : null;
  }

  function getPpcBuySubmit(form) {
    if (!form) return null;
    var productForm = form.closest('product-form');
    if (!productForm) return null;
    return productForm.querySelector('[type="submit"].product-form__submit, [type="submit"].vt-ppc__atc');
  }

  function ppcAddingLabel() {
    return (window.variantStrings && window.variantStrings.addingToCart) || 'Adding to cart...';
  }

  function setPpcCtaLoading(el, isLoading) {
    if (!el || el.classList.contains('vt-ppc__atc')) return;

    if (isLoading) {
      if (el.getAttribute('data-vt-ppc-adding') === 'true') return;
      el.setAttribute('data-vt-ppc-adding', 'true');
      el.setAttribute('aria-busy', 'true');
      el.classList.add('vt-ppc__cta--adding');
      if (!el.getAttribute('data-vt-ppc-label-saved')) {
        el.setAttribute('data-vt-ppc-label-saved', el.textContent.trim());
      }
      el.textContent = ppcAddingLabel();
      el.setAttribute('aria-disabled', 'true');
    } else {
      el.removeAttribute('data-vt-ppc-adding');
      el.removeAttribute('aria-busy');
      el.classList.remove('vt-ppc__cta--adding');
      var saved = el.getAttribute('data-vt-ppc-label-saved');
      if (saved) el.textContent = saved;
      el.removeAttribute('aria-disabled');
    }
  }

  function clearPpcCtaLoading() {
    document.querySelectorAll('[data-vt-ppc-adding="true"]').forEach(function (el) {
      setPpcCtaLoading(el, false);
    });
  }

  function initPpcCartFeedback() {
    if (!document.body.classList.contains('vt-ppc-funnel')) return;
    if (document.body.getAttribute('data-vt-ppc-cart-feedback') === 'true') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      window.addEventListener('load', initPpcCartFeedback, { once: true });
      return;
    }

    document.body.setAttribute('data-vt-ppc-cart-feedback', 'true');
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'product-form') clearPpcCtaLoading();
    });
    subscribe(PUB_SUB_EVENTS.cartError, function (event) {
      if (event && event.source === 'product-form') clearPpcCtaLoading();
    });
  }

  function isHgHeroAtc(el) {
    return el && (el.getAttribute('data-vt-ppc-hero-atc') === 'true' || (el.closest && el.closest('[data-vt-ppc-hg-hero-form]')));
  }

  function restoreHgHeroQty() {
    if (!document.body.classList.contains('vt-ppc-hg')) return;
    var form = document.querySelector('[data-vt-ppc-hg-hero-form] form, form[data-vt-ppc-hg-hero-form]');
    if (!form) return;
    var qtyInput = form.querySelector('[data-vt-ppc-quantity]');
    if (qtyInput) qtyInput.value = '1';
  }

  function resolvePpcAddQty(qty, triggerEl) {
    if (triggerEl && isHgHeroAtc(triggerEl)) return '1';
    if (qty != null && qty !== '') return String(qty);
    if (triggerEl && triggerEl.getAttribute('data-vt-ppc-bundle-qty')) {
      return triggerEl.getAttribute('data-vt-ppc-bundle-qty');
    }
    if (document.body.classList.contains('vt-ppc-hg') && !document.querySelector('[data-vt-ppc-bundle-picker]')) {
      return '2';
    }
    return qty;
  }

  function triggerPpcAddToCart(qty, triggerEl) {
    var form = getPpcBuyForm();
    var submit = getPpcBuySubmit(form);
    if (!form || !submit) {
      if (triggerEl) setPpcCtaLoading(triggerEl, false);
      return false;
    }

    var variantInput = form.querySelector('[name="id"], [data-vt-ppc-variant-id]');
    if (variantInput && variantInput.disabled && submit.disabled) {
      if (triggerEl) setPpcCtaLoading(triggerEl, false);
      return false;
    }
    if (variantInput && variantInput.disabled && !submit.disabled) {
      variantInput.disabled = false;
    }

    if (submit.disabled) {
      if (triggerEl) setPpcCtaLoading(triggerEl, false);
      return false;
    }

    if (submit.getAttribute('aria-disabled') === 'true' && submit.classList.contains('loading')) {
      return false;
    }
    if (submit.getAttribute('aria-disabled') === 'true' && !submit.classList.contains('loading')) {
      submit.removeAttribute('aria-disabled');
    }

    qty = resolvePpcAddQty(qty, triggerEl);

    if (qty != null && qty !== '') selectBundleQty(qty);

    var qtyInput = form.querySelector('[data-vt-ppc-quantity]');
    if (qty != null && qty !== '' && qtyInput) qtyInput.value = String(qty);

    if (document.body.classList.contains('vt-ppc-hg') && !isHgHeroAtc(triggerEl) && qty != null && qty !== '') {
      form.setAttribute('data-vt-ppc-pending-qty', String(qty));
    } else {
      form.removeAttribute('data-vt-ppc-pending-qty');
    }

    if (triggerEl && triggerEl !== submit) {
      setPpcCtaLoading(triggerEl, true);
      window.setTimeout(function () {
        if (triggerEl.getAttribute('data-vt-ppc-adding') === 'true') setPpcCtaLoading(triggerEl, false);
      }, 15000);
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submit);
    } else {
      submit.click();
    }

    if (document.body.classList.contains('vt-ppc-hg') && !isHgHeroAtc(triggerEl)) {
      window.setTimeout(restoreHgHeroQty, 0);
    }
    return true;
  }

  function initHgHeroForm(root) {
    root = root || document;
    root.querySelectorAll('[data-vt-ppc-hg-hero-form] form, form[data-vt-ppc-hg-hero-form]').forEach(function (form) {
      if (form.getAttribute('data-vt-ppc-hg-hero-init') === 'true') return;
      form.setAttribute('data-vt-ppc-hg-hero-init', 'true');
      form.addEventListener('submit', function () {
        var qtyInput = form.querySelector('[data-vt-ppc-quantity]');
        if (!qtyInput) return;
        var pending = form.getAttribute('data-vt-ppc-pending-qty');
        if (pending) {
          qtyInput.value = pending;
          form.removeAttribute('data-vt-ppc-pending-qty');
          return;
        }
        qtyInput.value = '1';
      });
    });
  }

  function ppcSoldOutLabel(sticky) {
    sticky = sticky || document.querySelector('[data-vt-ppc-sticky]');
    if (sticky && sticky.getAttribute('data-sold-out-label')) {
      return sticky.getAttribute('data-sold-out-label');
    }
    return (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
  }

  function syncPpcStickySoldOut() {
    var sticky = document.querySelector('[data-vt-ppc-sticky]');
    if (!sticky) return;
    var btn = sticky.querySelector('[data-vt-ppc-sticky-atc]');
    var heroSubmit = document.querySelector('.vt-ppc__atc');
    if (!btn) return;

    var unavailable =
      sticky.getAttribute('data-variant-available') === 'false' ||
      (heroSubmit && heroSubmit.disabled);

    var atcLabel = btn.getAttribute('data-atc-label') || sticky.getAttribute('data-atc-label') || 'Add to cart';

    if (unavailable) {
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = ppcSoldOutLabel(sticky);
      return;
    }

    btn.disabled = false;
    btn.removeAttribute('aria-disabled');
    btn.textContent = atcLabel;
  }

  function initStickyAtc() {
    var sticky = document.querySelector('[data-vt-ppc-sticky]');
    if (!sticky || sticky.getAttribute('data-vt-ppc-sticky-init') === 'true') return;
    sticky.setAttribute('data-vt-ppc-sticky-init', 'true');
    var btn = sticky.querySelector('[data-vt-ppc-sticky-atc]');
    if (!btn) return;
    syncPpcStickySoldOut();
    btn.addEventListener('click', function () {
      if (btn.disabled || btn.getAttribute('data-vt-ppc-adding') === 'true') return;
      var qty = null;
      if (!document.querySelector('[data-vt-ppc-bundle-picker]')) {
        qty = sticky.getAttribute('data-default-qty') || '1';
      }
      triggerPpcAddToCart(qty, btn);
    });

    if (!document.querySelector('[data-vt-ppc-bundle-picker]')) {
      var initQty = sticky.getAttribute('data-default-qty') || '2';
      updateStickyBar(initQty);
    }

    initStickyAtcVisibility(sticky);
  }

  function initStickyAtcVisibility(sticky) {
    if (sticky.getAttribute('data-vt-ppc-sticky-visibility-init') === 'true') return;
    sticky.setAttribute('data-vt-ppc-sticky-visibility-init', 'true');

    var atc = document.querySelector('.vt-ppc__atc');
    if (!atc) return;

    var mobileMq = window.matchMedia('(max-width: 989px)');
    var atcObserver = null;

    function setVisible(show) {
      sticky.classList.toggle('is-visible', show);
    }

    function disconnectObserver() {
      if (atcObserver) {
        atcObserver.disconnect();
        atcObserver = null;
      }
    }

    function bindDesktopHeroObserver() {
      disconnectObserver();
      setVisible(false);

      if (typeof IntersectionObserver === 'undefined') {
        return;
      }

      var heroRoot = document.getElementById('vt-ppc-buy');
      var heroSection = heroRoot ? heroRoot.closest('.shopify-section') : null;
      if (!heroSection) {
        return;
      }

      atcObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var rect = entry.boundingClientRect;
            if (entry.isIntersecting) {
              setVisible(false);
              return;
            }
            setVisible(rect.bottom <= 0);
          });
        },
        { root: null, threshold: 0 }
      );
      atcObserver.observe(heroSection);
    }

    function bindMobileAtcObserver() {
      disconnectObserver();
      if (typeof IntersectionObserver === 'undefined') {
        setVisible(true);
        return;
      }
      atcObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            setVisible(!entry.isIntersecting);
          });
        },
        { root: null, threshold: 0, rootMargin: '0px 0px -8px 0px' }
      );
      atcObserver.observe(atc);
    }

    function applyMode() {
      if (mobileMq.matches) {
        bindMobileAtcObserver();
      } else {
        bindDesktopHeroObserver();
      }
    }

    applyMode();
    mobileMq.addEventListener('change', applyMode);
  }

  function initBundlePicker(form) {
    if (form.getAttribute('data-vt-ppc-form-init') === 'true') return;
    form.setAttribute('data-vt-ppc-form-init', 'true');

    var picker = form.querySelector('[data-vt-ppc-bundle-picker]');
    if (!picker) return;
    var qtyInput = form.querySelector('[data-vt-ppc-quantity]');
    var atcText = form.querySelector('[data-vt-ppc-atc-text]');
    var label = picker.getAttribute('data-atc-label') || 'Add to cart';
    var prices = {
      1: parseInt(picker.getAttribute('data-price-1'), 10),
      2: parseInt(picker.getAttribute('data-price-2'), 10),
      3: parseInt(picker.getAttribute('data-price-3'), 10),
    };

    function apply(qty) {
      qty = String(qty);
      if (qtyInput) qtyInput.value = qty;
      picker.querySelectorAll('.vt-ppc__bundle-opt').forEach(function (opt) {
        var input = opt.querySelector('[data-vt-ppc-bundle-radio]');
        opt.classList.toggle('is-selected', input && input.value === qty);
      });
      var submitBtn = form.querySelector('[data-vt-ppc-atc]');
      if (submitBtn && submitBtn.disabled) {
        var soldOut = ppcSoldOutLabel();
        if (atcText) atcText.textContent = soldOut;
        syncPpcStickySoldOut();
        return;
      }
      if (atcText && !isNaN(prices[qty]) && prices[qty] > 0) {
        atcText.textContent = label + ' · ' + formatMoney(prices[qty]);
      } else if (atcText) {
        atcText.textContent = label;
      }
      updateStickyBar(qty);
    }

    picker.querySelectorAll('[data-vt-ppc-bundle-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio.value);
      });
    });

    var checked = picker.querySelector('[data-vt-ppc-bundle-radio]:checked');
    apply(checked ? checked.value : '2');

    form._vtPpcApplyBundle = apply;
  }

  function initScrollTo(root) {
    root = root || document;
    root.querySelectorAll('[data-vt-ppc-scroll-to]').forEach(function (el) {
      if (el.getAttribute('data-vt-ppc-scroll-to-init') === 'true') return;
      el.setAttribute('data-vt-ppc-scroll-to-init', 'true');
      el.addEventListener('click', function (e) {
        var sel = el.getAttribute('data-vt-ppc-scroll-to');
        if (!sel) return;
        var dest = document.querySelector(sel);
        if (!dest) return;
        e.preventDefault();
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        dest.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initHgInboxScroll(root) {
    root = root || document;
    root.querySelectorAll('[data-vt-hg-inbox-scroll]').forEach(function (wrap) {
      if (wrap.getAttribute('data-vt-hg-inbox-init') === 'true') return;
      wrap.setAttribute('data-vt-hg-inbox-init', 'true');

      var track = wrap.querySelector('[data-vt-hg-inbox-track]');
      var prev = wrap.querySelector('.vt-ppc-hg__inbox-scroll-btn--prev');
      var next = wrap.querySelector('.vt-ppc-hg__inbox-scroll-btn--next');
      if (!track || !prev || !next) return;

      function scrollStep() {
        return Math.max(260, Math.round(track.clientWidth * 0.72));
      }

      function updateButtons() {
        var scrollable = track.scrollWidth > track.clientWidth + 4;
        if (!scrollable) {
          prev.hidden = true;
          next.hidden = true;
          return;
        }
        prev.hidden = track.scrollLeft <= 4;
        next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(updateButtons);
        ro.observe(track);
      }
      updateButtons();
    });
  }

  function initHgRoutine(root) {
    root = root || document;
    root.querySelectorAll('[data-vt-ppc-hg-routine]').forEach(function (section) {
      if (section.getAttribute('data-vt-ppc-hg-routine-init') === 'true') return;
      section.setAttribute('data-vt-ppc-hg-routine-init', 'true');
      var steps = section.querySelectorAll('[data-vt-ppc-hg-routine-step]');
      var total = steps.length;
      if (!total) return;

      var FILL_MS = 1000;
      var STEP_PAUSE_MS = 350;
      var sequenceToken = 0;
      var sequenceTimers = [];
      var userPaused = false;
      var isVisible = false;
      var hasPlayedSequence = false;
      var sequenceRunning = false;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function clearTimers() {
        sequenceTimers.forEach(function (id) {
          clearTimeout(id);
        });
        sequenceTimers = [];
      }

      function schedule(fn, delay) {
        var id = setTimeout(fn, delay);
        sequenceTimers.push(id);
        return id;
      }

      function setHighlight(index) {
        steps.forEach(function (step) {
          var n = parseInt(step.getAttribute('data-vt-ppc-hg-routine-step'), 10);
          step.classList.toggle('is-active', n === index);
        });
      }

      function resetProgress() {
        steps.forEach(function (step) {
          step.classList.remove('is-filled', 'is-active');
        });
      }

      function markFilled(stepIndex) {
        var step = steps[stepIndex - 1];
        if (!step || step.classList.contains('is-filled')) return;
        setHighlight(stepIndex);
        step.classList.add('is-filled');
      }

      function fillThrough(targetIndex, instant) {
        targetIndex = Math.max(1, Math.min(targetIndex, total));
        if (instant || reduceMotion) {
          resetProgress();
          for (var i = 1; i <= targetIndex; i++) {
            markFilled(i);
          }
          return;
        }

        var token = ++sequenceToken;
        clearTimers();
        resetProgress();

        function runStep(stepNum) {
          if (token !== sequenceToken || userPaused) return;
          if (stepNum > targetIndex) return;

          markFilled(stepNum);

          if (stepNum < targetIndex) {
            schedule(function () {
              runStep(stepNum + 1);
            }, FILL_MS + STEP_PAUSE_MS);
          }
        }

        schedule(function () {
          runStep(1);
        }, 80);
      }

      function finishSequence() {
        hasPlayedSequence = true;
        sequenceRunning = false;
        for (var i = 1; i <= total; i++) {
          var step = steps[i - 1];
          if (step) step.classList.add('is-filled');
        }
        setHighlight(total);
      }

      function isSectionInView() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var visiblePx = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        return visiblePx >= Math.min(vh * 0.2, 120);
      }

      function playFullSequenceOnce() {
        if (hasPlayedSequence || sequenceRunning) return;
        if (!isSectionInView()) return;

        userPaused = false;
        isVisible = true;
        sequenceRunning = true;

        var token = ++sequenceToken;
        clearTimers();
        resetProgress();
        section.classList.add('is-routine-running');

        if (reduceMotion) {
          finishSequence();
          section.classList.remove('is-routine-running');
          sequenceRunning = false;
          return;
        }

        function runStep(stepNum) {
          if (token !== sequenceToken || hasPlayedSequence) return;

          if (stepNum > total) {
            finishSequence();
            section.classList.remove('is-routine-running');
            return;
          }

          markFilled(stepNum);
          schedule(function () {
            runStep(stepNum + 1);
          }, FILL_MS + STEP_PAUSE_MS);
        }

        schedule(function () {
          runStep(1);
        }, 120);
      }

      function tryStartWhenInView() {
        if (hasPlayedSequence || !isSectionInView()) return;
        playFullSequenceOnce();
      }

      function stopSequence() {
        sequenceToken++;
        sequenceRunning = false;
        clearTimers();
      }

      steps.forEach(function (step) {
        var n = parseInt(step.getAttribute('data-vt-ppc-hg-routine-step'), 10);
        step.addEventListener('mouseenter', function () {
          if (hasPlayedSequence) {
            setHighlight(n);
            return;
          }
          userPaused = true;
          stopSequence();
          fillThrough(n, false);
        });
        step.addEventListener('focusin', function () {
          if (hasPlayedSequence) {
            setHighlight(n);
            return;
          }
          userPaused = true;
          stopSequence();
          fillThrough(n, false);
        });
        step.addEventListener('click', function () {
          if (hasPlayedSequence) {
            setHighlight(n);
            return;
          }
          userPaused = true;
          stopSequence();
          fillThrough(n, false);
        });
      });

      section.addEventListener('mouseleave', function () {
        userPaused = false;
        if (hasPlayedSequence) {
          setHighlight(total);
        }
      });

      if (typeof IntersectionObserver !== 'undefined') {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              isVisible = entry.isIntersecting;
              if (entry.isIntersecting && entry.intersectionRatio > 0 && !hasPlayedSequence) {
                tryStartWhenInView();
              } else if (!entry.isIntersecting && !hasPlayedSequence) {
                stopSequence();
                resetProgress();
                section.classList.remove('is-routine-running');
              }
            });
          },
          { threshold: [0, 0.1, 0.2, 0.35], rootMargin: '0px 0px 0px 0px' }
        );
        observer.observe(section);

        window.addEventListener(
          'scroll',
          function () {
            tryStartWhenInView();
          },
          { passive: true }
        );

        window.addEventListener(
          'resize',
          function () {
            tryStartWhenInView();
          },
          { passive: true }
        );

        requestAnimationFrame(function () {
          tryStartWhenInView();
        });
      } else {
        window.addEventListener(
          'scroll',
          function () {
            tryStartWhenInView();
          },
          { passive: true }
        );
        tryStartWhenInView();
      }
    });
  }

  function initScrollCtas(root) {
    root = root || document;
    var target = document.getElementById('vt-ppc-buy');

    root.querySelectorAll('[data-vt-ppc-scroll-buy]').forEach(function (el) {
      if (el.getAttribute('data-vt-ppc-scroll-init') === 'true') return;
      el.setAttribute('data-vt-ppc-scroll-init', 'true');

      el.addEventListener('click', function (e) {
        var href = el.getAttribute('href');
        if (!href || href === '#' || href === '#vt-ppc-buy') e.preventDefault();

        if (el.getAttribute('data-vt-ppc-adding') === 'true') {
          e.preventDefault();
          return;
        }

        var qty = el.getAttribute('data-vt-ppc-bundle-qty');

        if (shouldAddToCartFromCta(el)) {
          if (triggerPpcAddToCart(qty, el)) return;
          setPpcCtaLoading(el, false);
          return;
        }

        if (!target) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  function initTrustSlider(root) {
    root = root || document;
    root.querySelectorAll('[data-vt-ppc-trust-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-vt-ppc-trust-init') === 'true') return;
      slider.setAttribute('data-vt-ppc-trust-init', 'true');

      var track = slider.querySelector('[data-vt-ppc-trust-track]');
      var viewport = slider.querySelector('[data-vt-ppc-trust-viewport]');
      var prevBtn = slider.querySelector('[data-vt-ppc-trust-prev]');
      var nextBtn = slider.querySelector('[data-vt-ppc-trust-next]');
      if (!track) return;

      var slideCount = 0;
      var index = 0;
      var isResetting = false;

      function slidesPerView() {
        var mobile = parseInt(slider.getAttribute('data-slides-mobile'), 10) || 1;
        var desktop = parseInt(slider.getAttribute('data-slides-desktop'), 10) || 4;
        return window.matchMedia('(max-width: 989px)').matches ? mobile : desktop;
      }

      function canSlide() {
        if (slider.getAttribute('data-vt-ppc-trust-always-slide') === 'true') {
          return slideCount > 1;
        }
        return slideCount > slidesPerView();
      }

      function removeLoopClones() {
        track.querySelectorAll('[data-vt-ppc-clone]').forEach(function (node) {
          node.parentNode.removeChild(node);
        });
      }

      function refreshSlideCount() {
        slideCount = track.querySelectorAll('.vt-ppc__trust-review:not([data-vt-ppc-clone])').length;
      }

      function appendLoopClones() {
        removeLoopClones();
        refreshSlideCount();
        if (!slideCount) return;

        var originals = track.querySelectorAll('.vt-ppc__trust-review:not([data-vt-ppc-clone])');
        for (var i = 0; i < slideCount; i++) {
          var clone = originals[i].cloneNode(true);
          clone.setAttribute('data-vt-ppc-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
        }
      }

      function stepSize() {
        var first = track.querySelector('.vt-ppc__trust-review:not([data-vt-ppc-clone])');
        if (!first) return 0;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
        return first.getBoundingClientRect().width + gap;
      }

      function setTransition(enabled) {
        track.style.transition = enabled ? '' : 'none';
      }

      function syncControls() {
        var enabled = canSlide();
        if (prevBtn) prevBtn.disabled = !enabled;
        if (nextBtn) nextBtn.disabled = !enabled;
      }

      function applyTransform() {
        track.style.transform = 'translateX(' + -index * stepSize() + 'px)';
        syncControls();
      }

      function snapToStart() {
        isResetting = true;
        setTransition(false);
        index = 0;
        applyTransform();
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            setTransition(true);
            isResetting = false;
          });
        });
      }

      function onLoopTransitionEnd(event) {
        if (event.target !== track || event.propertyName !== 'transform' || isResetting) return;
        if (index >= slideCount) snapToStart();
      }

      track.addEventListener('transitionend', onLoopTransitionEnd);

      function moveBy(delta) {
        if (!canSlide()) return;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (delta > 0) {
          if (index >= slideCount) {
            // Missed transitionend (e.g. tab was hidden): reset before moving on
            setTransition(false);
            index = 0;
            applyTransform();
            void track.offsetWidth;
            setTransition(true);
          }
          index += 1;
          applyTransform();
          if (reduceMotion && index >= slideCount) snapToStart();
          else if (index >= slideCount) {
            window.setTimeout(function () {
              if (index >= slideCount && !isResetting) snapToStart();
            }, 1200);
          }
          return;
        }

        if (index === 0) {
          setTransition(false);
          index = slideCount;
          applyTransform();
          window.requestAnimationFrame(function () {
            index = slideCount - 1;
            setTransition(!reduceMotion);
            applyTransform();
          });
          return;
        }

        index -= 1;
        applyTransform();
      }

      var autoplayTimer = null;
      var AUTOPLAY_MS = 5000;

      function stopAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function startAutoplay() {
        stopAutoplay();
        if (!canSlide()) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        autoplayTimer = setInterval(function () {
          moveBy(1);
        }, AUTOPLAY_MS);
      }

      function restartAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      function rebuildSlider() {
        appendLoopClones();
        if (index >= slideCount) index = 0;
        applyTransform();
        restartAutoplay();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          moveBy(-1);
          restartAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          moveBy(1);
          restartAutoplay();
        });
      }

      if (viewport) {
        var touchStartX = 0;
        var touchActive = false;

        viewport.addEventListener(
          'touchstart',
          function (event) {
            if (!canSlide() || event.touches.length !== 1) return;
            touchStartX = event.touches[0].clientX;
            touchActive = true;
            stopAutoplay();
          },
          { passive: true }
        );

        viewport.addEventListener(
          'touchend',
          function (event) {
            if (!touchActive) return;
            touchActive = false;
            var deltaX = event.changedTouches[0].clientX - touchStartX;
            if (Math.abs(deltaX) < 36) {
              restartAutoplay();
              return;
            }
            moveBy(deltaX < 0 ? 1 : -1);
            restartAutoplay();
          },
          { passive: true }
        );
      }

      // Only rebuild when the width really changes (mobile URL bar resizes on scroll)
      var lastWidth = window.innerWidth;
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(rebuildSlider, 150);
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      appendLoopClones();
      if (!slideCount) return;
      applyTransform();
      startAutoplay();
    });
  }

  function clearStuckScrollLock() {
    if (!document.body.classList.contains('vt-ppc-funnel')) return;
    document.documentElement.classList.remove('vt-promo-popup-open');
    document.body.classList.remove('vt-promo-popup-open', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
    var main = document.getElementById('MainContent');
    if (main) {
      main.removeAttribute('inert');
      main.removeAttribute('aria-hidden');
    }
  }

  function initAll(root) {
    clearStuckScrollLock();
    initPpcCartFeedback();
    root = root || document;
    root.querySelectorAll('[data-vt-ppc-gallery]').forEach(initGallery);
    initStickyAtc();
    root.querySelectorAll('product-form.vt-ppc__buy-form form').forEach(initBundlePicker);
    syncPpcStickySoldOut();
    initScrollCtas(root);
    initScrollTo(root);
    initHgRoutine(root);
    initHgInboxScroll(root);
    initHgHeroForm(root);
    initTrustSlider(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
